var SubcheckOutcomeCtrl = function ($scope) {
  const outOfScopeFields = [
    "status1LookupValId",
    "outcomeLookupValId",
    "customAutomatedStatusUpdateSetting",
    "closeToExpiry",
    "outcomeNote",
    "comments",
    "knownAs",
    "status",
    "status1Name",
  ];

  const referencingLookupValId = 6004


  $scope.checkSectionFieldsAreAllFilled = function (sectionTarget, sectionTargetLookupValId) {
    if(sectionTargetLookupValId === referencingLookupValId) return;

    $scope.showEmptySectionMessage = false;
    const section = $scope.formModel.subcheckList[findIndex(sectionTarget)];

    setTimeout(function () {
      $scope.showEmptySectionMessage = !Object.keys(section).some(function (
        key
      ) {
        if (outOfScopeFields.includes(key)) return false;
        return section[key] !== '' && section[key] != "null";
      });

      if ($scope.showEmptySectionMessage) {
        section.outcomeLookupValId = "";
      }
    });
  };

  function findIndex(sectionTarget) {
    return sectionTarget.match(/[\d]+/g)[0];
  }
};
SubcheckOutcomeCtrl.$inject = ["$scope"];
angular.module("app").controller("SubcheckOutcomeCtrl", SubcheckOutcomeCtrl);
